import { Icon20RefreshOutline } from '@vkontakte/icons';
import React, { type FC, memo } from 'react';

import styles from './AiPhotoGenerationButtonRefresh.css';

interface IProps {
    onClick: () => void;
}

export const AiPhotoGenerationButtonRefresh: FC<IProps> = memo(function AiPhotoGenerationButtonGenerateAgain(props) {
    const { onClick } = props;

    return (
        <div className={styles.button} onClick={onClick}>
            <Icon20RefreshOutline data-qa-id="again-icon" />
            Сгенерировать ещё&nbsp;раз
        </div>
    );
});
